import { Component, OnInit } from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import {BeeztelCodesService} from '../../services/beeztel-codes.service';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';
import {Observable} from 'rxjs/Rx';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../../../core/service/auth.service';
import {MiscelaneaService} from '../../../../../shared/services/miscelanea.service';

import Swal from "sweetalert2";
import * as _ from 'underscore';

@Component({
  selector: 'app-code-mapping-change-edit',
  templateUrl: './code-mapping-change-edit.component.html',
  styleUrls: ['./code-mapping-change-edit.component.scss']
})
export class CodeMappingChangeEditComponent extends ModalExtended implements OnInit {

    data: any;
    currentCodes: Array<Object> = [];
    status: any = [];
    statusDoi: any = [];
    formData: FormGroup;

    enabled: boolean = false;
    submitted: boolean = false;

    constructor(private codesHandler: BeeztelCodesService, private messaging: MessagingService, private auth: AuthService, private misc: MiscelaneaService) {
        super();

        this.formData = new FormGroup({
            pk_original_code: new FormControl({ value: '', disabled: true }, Validators.required),
            new_status: new FormControl('', Validators.required),
            new_status_doi: new FormControl(),
            num_attempts: new FormControl(),
            allowed_codes: new FormControl(),
            line_type: new FormControl(),
            failover_campaign_retry_pk: new FormControl()
        });
    }

    onExit(): void {
        this.applyCallback(true);
        this.close();
    }

    requestAutocompleteItems = (text: string): Observable<Response> => {
        return this.misc.findAllPhonePossibleResponses(
            {
                provider: 'beeztel'
            }, text
        );
    };

    createCodeMappingChange(): void {

        if(!this.formData.valid){
            this.submitted = true;
            return;
        }

        this.enabled = true;
        var formValues = this.codesHandler.parseForCreateMappingChange(this.formData.value);
        this.codesHandler.createMappingChange(formValues).subscribe(
            (result) => {
                Swal({ type: 'success', title: 'Action performed', text: 'Code mapping change created successfully'});
                this.enabled = false;
            }
        )
    }

    updateCodeMappingChange(): void {

        if(!this.formData.valid){
            this.submitted = true;
            return;
        }

        this.enabled = true;
        var formValues = this.codesHandler.parseForCreateMappingChange(this.formData.value);
        this.codesHandler.updateMappingChange(this.data['pk'], formValues).subscribe(
            (result) => {
                Swal({ type: 'success', title: 'Action performed', text: 'Code mapping change updated successfully'});
                this.enabled = false;
            }
        )
    }

    getCodes(): void {
        this.formData.controls['pk_original_code'].disable();
        this.codesHandler.getPortalBeeztelCodes(this.auth.getPortalSelected().portal).subscribe(
            (result) => {
                this.currentCodes = result;
                this.formData.controls['pk_original_code'].enable();
            }
        )
    }

    ngOnInit() {
        Observable
            .forkJoin(this.codesHandler.getPortalBeeztelCodes(this.auth.getPortalSelected().portal), this.codesHandler.getStatusList(), this.codesHandler.getStatusDoiList())
            .subscribe(
                (result) => {
                    this.currentCodes = result[0];
                    this.status = result[1];
                    this.statusDoi = result[2];

                    this.statusDoi = this.statusDoi.filter( (o) => { return o.id != 'DOI_LINE_WHATSAPP'; });

                    this.formData.controls['pk_original_code'].enable();
                }
            );

        if(this.data.hasOwnProperty('pk')){
            this.formData.controls['pk_original_code'].setValue(this.data['pk_original_code']);
            this.formData.controls['new_status'].setValue(this.data['new_status']);
            this.formData.controls['new_status_doi'].setValue(this.data['new_status_doi']);
            this.formData.controls['num_attempts'].setValue(this.data['num_attempts']);
            this.formData.controls['line_type'].setValue(this.data['line_type']);
            this.formData.controls['failover_campaign_retry_pk'].setValue(this.data['failover_campaign_retry_pk']);

            if(!_.isUndefined(this.data['allowed_codes'])){
                let allowedCodes = [];
                this.data['allowed_codes'].forEach( (code) => { allowedCodes.push({ 'value' : code, 'display' : code}); });
                this.formData.controls['allowed_codes'].setValue(allowedCodes);
            }


        }

        this.messaging.message.subscribe(
            (result) => {
                if(result instanceof VnaPortalSelected){
                    this.currentCodes = [];
                    this.getCodes();
                }
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/beeztel-codes/modals/code-mapping-change-edit/code-mapping-change-edit.component.ts